<ul class="nav nav-pills" role="tablist">
  <li role="presentation" class="active custom-pill">
    <a
      href="#{{ idPrefix }}usr{{ data.type }}ChartTab"
      style="font-size: 11px"
      role="tab"
      data-toggle="tab"
      [attr.aria-controls]="'#{{idPrefix}}usr{{data.type}}ChartTab'">
      Pie Chart
    </a>
  </li>

  <li role="presentation" class="custom-pill">
    <a
      href="#{{ idPrefix }}usr{{ data.type }}TableTab"
      style="font-size: 11px"
      role="tab"
      data-toggle="tab"
      [attr.aria-controls]="'#{{idPrefix}}usr{{data.type}}TableTab'">
      Table
    </a>
  </li>
</ul>
<div class="tab-content">
  <div role="tabpanel" class="tab-pane fade in active" id="{{ idPrefix }}usr{{ data.type }}ChartTab">
    <div id="{{ idPrefix }}usr{{ data.type }}"></div>
  </div>

  <div role="tabpanel" class="tab-pane fade in" id="{{ idPrefix }}usr{{ data.type }}TableTab">
    <div class="row">
      <div class="col-xs-12">
        <h3 class="m-t-sm text-center">{{ data.displayTitle }}</h3>
        <table class="table" id="{{ idPrefix }}usr{{ data.type }}Table" style="width: 100%">
          <thead>
            <tr>
              <th>Unit Operation</th>
              <th>Mass Flowrate</th>
            </tr>
          </thead>

          <tfoot>
            <tr>
              <th class="text-right">Total</th>
              <th>{{ data.total | thousandSeparator }}</th>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</div>
